<template>
  <v-list-item>
    <v-list-item-title>{{ $t("chat.name") }}</v-list-item-title>
    <v-btn
      color="primary"
      variant="outlined"
      :text="$t('chat.deleteAllChatHistory')"
      @click="deleteChats"
    ></v-btn>
    <v-btn
      color="primary"
      variant="outlined"
      :text="$t('chat.downloadAllChatHistory')"
      @click="downloadJson"
      style="margin: 10px"
    ></v-btn>
  </v-list-item>

  <ConfirmModal ref="confirmModal" />
  <v-snackbar
    v-model="snackbar.show"
    :timeout="snackbar.timeout"
    :color="snackbar.color"
  >
    {{ snackbar.text }}
  </v-snackbar>
</template>

<script setup>
import { ref, reactive } from "vue";
import { useStore } from "vuex";
import i18n from "@/i18n";

import ConfirmModal from "@/components/ConfirmModal.vue";
import bots from "@/bots";
import { download_by_link } from "@/utils";

const emit = defineEmits(["close-dialog"]);
const confirmModal = ref();
const store = useStore();

const snackbar = reactive({
  show: false,
  text: "",
  timeout: 1500,
  color: "success",
});

// This function downloads the chat history as a JSON file.

const downloadJson = () => {
  const messages = get_messages();
  if (!messages) {
    console.error("chatall-messages not found in localStorage");
    return;
  }

  // Create an array of messages from the chat history.
  const content = "history";
  download_by_link(messages, content);
};
function get_messages() {
  // Get the chat history from localStorage.
  const chatallMessages = localStorage.getItem("chatall-messages");
  if (!chatallMessages) {
    return;
  }

  const chats = JSON.parse(chatallMessages)?.chats ?? [];
  try {
    // Create an array of messages from the chat history.
    const messages = chats
      .filter((d) => !d.hide)
      .map((chat) => ({
        // The title of the chat.
        title: chat.title,
        // The messages in the chat.
        messages: chat.messages
          .filter((d) => !d.hide)
          .reduce((arr, message) => {
            const t = message.type;
            const content = message.content;
            if (t == "prompt") {
              arr.push({
                prompt: content,
                responses: [],
              });
            } else {
              const botClassname = message.className;
              const bot = bots.getBotByClassName(botClassname);
              if (bot) {
                const botName = bot.getFullname();
                arr.at(-1).responses.push({
                  content,
                  botName,
                  botClassname,
                  botModel: message.model,
                  highlight: message.highlight,
                });
              }
            }
            return arr;
          }, []),
      }));
    return messages;
  } catch (e) {
    // eslint-disable-next-line no-debugger
    debugger;
  }
}

async function deleteChats() {
  const confirm = await confirmModal.value.showModal(
    "",
    i18n.global.t("chat.confirmDeleteAllChatHistory"),
  );
  if (confirm) {
    store.commit("deleteChats");
    emit("close-dialog");
  }
}
</script>
@/utils/storage
